export const QUALITYFER_VIABILITY_MORTGAGES = '@qualityfer/QUALITYFER_VIABILITY_MORTGAGES';
export const QUALITYFER_VIABILITY_SUBROGATES = '@qualityfer/QUALITYFER_VIABILITY_SUBROGATES';
export const QUALITYFER_VIABILITY_ERROR = '@qualityfer/QUALITYFER_VIABILITY_ERROR';
export const QUALITYFER_VIABILITY_LOADING = '@qualityfer/QUALITYFER_VIABILITY_LOADING';
export const QUALITYFER_VIABILITY_RESET = '@qualityfer/QUALITYFER_VIABILITY_RESET';
export const GET_DATA_MORTGAGES_LOADING = '@qualityfer/GET_DATA_MORTGAGES_LOADING';
export const GET_DATA_MORTGAGES_ERROR = '@qualityfer/GET_DATA_MORTGAGES_ERROR';
export const GET_DATA_MORTGAGES_SUCCESS = '@qualityfer/GET_DATA_MORTGAGES_SUCCESS';
export const GET_DATA_MORTGAGES_DESELECTED = '@qualityfer/GET_DATA_MORTGAGES_DESELECTED';